import { Button, Select, Spin, Tag } from "antd";
import axios from "axios";
import moment from "moment/moment";
import React, { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import { AiOutlineFundView } from "react-icons/ai";
import { FaPlus, FaSearch } from "react-icons/fa";
import { FiEdit, FiEye, FiTrash, FiUploadCloud } from "react-icons/fi";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { api, endpoint } from "@/api";
import appConfig from "@/config/appConfig";
import { DataTable } from "@/components";
import { userRole } from "@/constant";
import { flare } from "@flareapp/js";

const DeviceList = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const { userDetails, business } = useSelector((state) => state?.user);
  const [limit, setLimit] = useState(Number(searchParams.get("limit")) || 10);
  const [page, setPage] = useState(Number(searchParams.get("page")) || 1);
  const [searchTerm, setSearchTerm] = useState(searchParams.get("s") || "");
  const [searchByLocation, setSearchByLocation] = useState(searchParams.get("site") || "");
  const [searchByStatus, setSearchByStatus] = useState(searchParams.get("status") || "");
  const [searchByDeviceType, setSearchByDeviceType] = useState(searchParams.get("type") || "");

  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [devices, setDevices] = useState([]);
  const [siteLocation, setSiteLocation] = useState([]);
  const [deviceTypes, setDeviceTypes] = useState([]);
  const [query, setQeury] = useState({
    type: searchParams.get("type") || "",
    site: searchParams.get("site") || "",
    status: searchParams.get("status") || "",
    searchText: searchParams.get("s") || "",
  });
  const navigate = useNavigate();

  useEffect(() => {
    setSearchTerm(searchParams.get("s") || "");
    setPage(Number(searchParams.get("page")) || 1);
    setLimit(Number(searchParams.get("limit")) || 10);
  }, [searchParams]);

  const getSiteLocation = async () => {
    try {
      const response = await axios.get(`/site-location/my-site`, {
        withCredentials: true,
        params: { business, unknown: true },
      });
      if (response) {
        setSiteLocation(response.data);
      }
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log("site location", error);
    }
  };
  // console.log({ page });
  const getDevices = async () => {
    setIsLoading(true);
    try {
      const response = await api.get(endpoint.get_devices, {
        params: {
          business,
          limit,
          page,
          sortBy: "createdAt",
          orderBy: "DESC",
          searchText: searchTerm,
          site: searchByLocation,
          status: searchByStatus,
          ...query,
        },
      });
      setDevices(response?.results);
      setTotal(response?.count);
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log(error);
    }
    setIsLoading(false);
  };
  useEffect(() => {
    getDevices();
  }, [limit, searchTerm, page, query, business]);

  useEffect(() => {
    getSiteLocation();
    const type = searchParams.get("type") || "";
    const status = searchParams.get("status") || "";
    const substation = searchParams.get("site") || "";
    setSearchByStatus(status);
    setSearchByLocation(substation);
    setSearchByDeviceType(type);
    setQeury({ status, site: substation, type });
  }, [business]);

  const getDeviceTypes = async () => {
    try {
      const response = await axios.get(`/device-type`, { withCredentials: true });
      if (response) {
        setDeviceTypes(response.data);
      }
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };

  useEffect(() => {
    document.title = `${appConfig.name} - All Devices`;
    getDeviceTypes();
  }, []);

  const isInitialRender = useRef(business);
  useEffect(() => {
    if (isInitialRender.current !== business) {
      navigate({});
      isInitialRender.current = business;
    }
  }, [business]);

  const navigateWithQuryParams = (payload) => {
    let queryParams = {};
    searchParams.forEach((value, key) => {
      queryParams[key] = value;
    });
    queryParams = new URLSearchParams({ ...queryParams, ...payload });
    navigate({ search: queryParams.toString() });
  };

  const handleSearch = () => {
    const obj = {};
    obj.type = searchByDeviceType;
    obj.site = searchByLocation;
    obj.status = searchByStatus;
    obj.page = 1;
    navigateWithQuryParams(obj);
    // obj.site = searchByLocation;
    delete obj.page;
    setQeury(obj);
  };

  const columns = [
    {
      title: "No.",
      render: (_, __, index) => <div>{(page - 1) * limit + index + 1}</div>,
      maxWidth: "60px",
      align: "center",
    },
    {
      title: "Device Name",
      render: (row) => row?.name,
    },
    {
      title: "Device Type",
      render: (row) => <div className="text-wrap">{row?.deviceType?.name}</div>,
    },
    {
      title: "Site Name",
      render: (_, row) => <div className="text-wrap">{row?.site?.name}</div>,
    },
    {
      title: "Status",
      render: (_, row) => (
        <div className="text-wrap">
          {row?.status === "active" ? <Tag color="green">Online</Tag> : <Tag color="magenta">Offline</Tag>}
        </div>
      ),
    },
    {
      title: "Date Created",
      render: (row) => moment(row.createdAt).format("DD/MM/YYYY"),
      align: "center",
    },
    {
      title: "Action",
      width: "220px",
      align: "center",
      render: (_, row) => (
        <div>
          {(() => {
            switch (userDetails.role) {
              case "superAdmin":
                return (
                  <div className="">
                    <Link to={`/devices/details/` + row._id} className="btn btn-az-primary me-1">
                      <FiEye />
                    </Link>
                    <Link to={`/devices/edit/` + row._id} className="btn btn-edit me-1">
                      <FiEdit />
                    </Link>
                    <Link to={`/devices/data/` + row._id} className="btn btn-warning me-1">
                      <AiOutlineFundView />
                    </Link>
                    <button className="btn btn-danger" onClick={() => deleteDevice(row._id)}>
                      <FiTrash />
                    </button>
                  </div>
                );
              case userRole.businessAdmin:
                return (
                  <div className="">
                    <Link to={`/devices/details/` + row._id} className="btn btn-az-primary me-1">
                      <FiEye />
                    </Link>
                    <Link to={`/devices/edit/` + row._id} className="btn btn-edit me-1">
                      <FiEdit />
                    </Link>
                    <Link to={`/devices/data/` + row._id} className="btn btn-warning me-1">
                      <AiOutlineFundView />
                    </Link>
                    <button className="btn btn-danger" onClick={() => deleteDevice(row._id)}>
                      <FiTrash />
                    </button>
                  </div>
                );
              case "installer":
                return (
                  <div className="">
                    <Link to={`/devices/details/` + row._id} className="btn btn-az-primary me-1">
                      <FiEye />
                    </Link>
                    <Link to={`/devices/edit/` + row._id} className="btn btn-edit me-1">
                      <FiEdit />
                    </Link>
                    <Link to={`/devices/data/` + row._id} className="btn btn-warning me-1">
                      <AiOutlineFundView />
                    </Link>
                    <button className="btn btn-danger" onClick={() => deleteDevice(row._id)}>
                      <FiTrash />
                    </button>
                  </div>
                );
              case "admin":
                return (
                  <div className="">
                    <Link to={`/devices/details/` + row._id} className="btn btn-az-primary me-1">
                      <FiEye />
                    </Link>
                    <Link to={`/devices/edit/` + row._id} className="btn btn-edit me-1">
                      <FiEdit />
                    </Link>
                    <Link to={`/devices/data/` + row._id} className="btn btn-warning me-1">
                      <AiOutlineFundView />
                    </Link>
                    <button className="btn btn-danger" onClick={() => deleteDevice(row._id)}>
                      <FiTrash />
                    </button>
                  </div>
                );
              case "user":
                return (
                  <div className="">
                    <Link to={`/devices/details/` + row._id} className="btn btn-az-primary me-1">
                      <FiEye />
                    </Link>
                    <Link to={`/devices/edit/` + row._id} className="btn btn-edit me-1">
                      <FiEdit />
                    </Link>
                    <Link to={`/devices/data/` + row._id} className="btn btn-warning me-1">
                      <AiOutlineFundView />
                    </Link>
                    <button className="btn btn-danger" onClick={() => deleteDevice(row._id)}>
                      <FiTrash />
                    </button>
                  </div>
                );
              case "public":
                return (
                  <div className="">
                    <Link to={`/devices/details/` + row._id} className="btn btn-az-primary me-1">
                      <FiEye />
                    </Link>
                    <Link to={`/devices/data/` + row._id} className="btn btn-warning me-1">
                      <AiOutlineFundView />
                    </Link>
                  </div>
                );
              default:
                return;
            }
          })()}
        </div>
      ),
    },
  ];

  const deleteDevice = async (deviceId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this device?",
      //icon: "warning",
      dangerMode: true,
      showCancelButton: true,
      confirmButtonText: "Confirm",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`/device/` + deviceId, {
            withCredentials: true,
          })
          .then(() => {
            getDevices();
            Swal.fire({
              title: "Done!",
              text: "Device Deleted Successfully",
              icon: "info",
              timer: 2000,
              button: false,
            });
          });
      }
    });
  };

  return (
    <div className="card p-3 m-md-3">
      <div className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between pb-3">
        <div>
          <label className="az-content-label">Manage Device</label>
          <span className="d-block py-2">All Device</span>
        </div>
        <div className="d-flex flex-column flex-sm-row  justify-content-md-end p-0 gap-2">
          <Link to="/device-csv-upload">
            <Button icon={<FiUploadCloud />} danger type="primary">
              Bulk CSV Upload
            </Button>
          </Link>
          <Link to="/add-devices">
            <Button icon={<FaPlus />} type="primary">
              Add New Device
            </Button>
          </Link>
        </div>
      </div>

      <hr className="mt-0" />
      <div className="row my-3 g-2">
        <div className="col-md-3">
          <Select
            style={{ width: "100%" }}
            size="large"
            showSearch={true}
            filterOption={(input, option) =>
              // eslint-disable-next-line no-unsafe-optional-chaining
              (option?.children ? option?.children?.toLowerCase() : "").includes(input?.toLowerCase())
            }
            value={searchByLocation || ""}
            onChange={(e) => setSearchByLocation(e)}
          >
            <Select.Option value="">All Site Location</Select.Option>
            {Array.isArray(siteLocation) &&
              siteLocation.length > 0 &&
              siteLocation?.map((item, index) => (
                <Select.Option value={item._id} key={index}>
                  {item.name}
                </Select.Option>
              ))}
          </Select>
        </div>
        <div className="col-md-2">
          <Select
            style={{ width: "100%" }}
            size="large"
            showSearch={true}
            filterOption={(input, option) =>
              // eslint-disable-next-line no-unsafe-optional-chaining
              (option?.children ? option?.children?.toLowerCase() : "").includes(input?.toLowerCase())
            }
            value={searchByDeviceType || ""}
            onChange={(e) => setSearchByDeviceType(e)}
          >
            <Select.Option value="">All Device Types</Select.Option>
            {Array.isArray(deviceTypes) &&
              deviceTypes?.map((item, index) => (
                <Select.Option value={item._id} key={index}>
                  {item.name}
                </Select.Option>
              ))}
          </Select>
        </div>
        <div className="col-md-2">
          <Select className="w-100" value={searchByStatus || ""} size="large" onChange={(e) => setSearchByStatus(e)}>
            <Select.Option value="">All Status</Select.Option>
            <Select.Option value="active">Online</Select.Option>
            <Select.Option value="inactive">Offline</Select.Option>
          </Select>
        </div>
        <div className="col-md-2">
          <button onClick={handleSearch} className="btn bg-secondary-subtle text-black">
            <FaSearch />
          </button>
        </div>
        <div className="col-md-1"></div>

        <div className="col-md-2">
          <Form className="d-flex">
            <Form.Control
              type="search"
              value={searchTerm}
              onChange={(e) => navigateWithQuryParams({ s: e.target.value, page: 1 })}
              placeholder="Search"
              className="me-2"
              aria-label="Search"
            />
          </Form>
        </div>
      </div>
      <Spin spinning={isLoading}>
        <DataTable
          rowKey={(record) => record.id}
          columns={columns}
          dataSource={devices}
          pagination={{
            pageSize: limit,
            current: page,
            total,
            showSizeChanger: true,
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
            pageSizeOptions: [10, 20, 50],
            responsive: true,
          }}
          onChange={(pagination) =>
            navigateWithQuryParams({
              page: pagination.current,
              limit: pagination.pageSize,
            })
          }
        />
      </Spin>
    </div>
  );
};

export default DeviceList;
